import { CarrierVisitDirection } from '@planning/app/api'
import {
  HoldEnforcementOrderInput,
  HoldValidationContext,
  useHoldEnforcement,
} from '@planning/utils/hold-enforcement'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { HoldEnforcementAlert } from './HoldEnforcementAlert'

interface Props {
  order: HoldEnforcementOrderInput
  context: HoldValidationContext
  direction?: CarrierVisitDirection | null
}

export const HoldEnforcementAlertWrapper: FC<Props> = observer(({ order, context, direction }) => {
  const { reaction, holdNames } = useHoldEnforcement(order, context, direction)

  return <HoldEnforcementAlert reaction={reaction} holdNames={holdNames} />
})
